import {View, Text, ScrollView, TouchableOpacity, SafeAreaView} from 'react-native';
import React from 'react';
import {FooterToastDrawer} from '@skillz/ui';
import {BankAccount} from 'StoreInfo';
import {_m} from 'INTL';
import SkillzSVG from 'SkillzSVG';
import {stylesFn} from './FooterSelectionDrawer.styles';

type FooterSelectionDrawerProps = {
  isDrawerVisible: boolean;
  onDismiss: () => void;
  bankAccounts: BankAccount[];
  onSelect: (bankAccount: BankAccount) => void;
  onLinkNewBankAccount: () => void;
  selectedBankAccount?: BankAccount | null;
};

const FooterSelectionDrawer = ({
  isDrawerVisible,
  bankAccounts,
  onDismiss,
  onSelect,
  onLinkNewBankAccount,
  selectedBankAccount,
}: FooterSelectionDrawerProps) => {
  const styles = stylesFn(isDrawerVisible);

  const handleOnDismiss = () => {
    onDismiss();
  };

  const handleSelectBankAccount = (bankAccount: BankAccount) => {
    onSelect(bankAccount);
  };

  const handleLinkBankAccount = () => {
    onLinkNewBankAccount();
  };

  const BankAccountItem = (bankAccount: BankAccount) => {
    const isSelected = selectedBankAccount?.id === bankAccount.id;
    return (
      <TouchableOpacity
        style={
          isSelected ? styles.bankAccountItemContainerSelected : styles.bankAccountItemContainer
        }
        onPress={() => handleSelectBankAccount(bankAccount)}
      >
        <View style={styles.bankAccountNameContainer}>
          {isSelected && <SkillzSVG source={'blue_check_icon.svg'} style={styles.blueCheckIcon} />}
          <Text style={styles.bankAccountName} allowFontScaling={false}>{bankAccount.name}</Text>
        </View>
        <Text style={styles.bankName} allowFontScaling={false}>{bankAccount.bank_name}</Text>
      </TouchableOpacity>
    );
  };
  return (
    <View style={styles.footerToastContainer}>
      <FooterToastDrawer
        onDismiss={handleOnDismiss}
        title={_m('Select your Bank')}
        visible={isDrawerVisible}
        maxHeight={350}
        gradientColors={['#FFF', '#FFF', '#FFF']}
        gradientLocations={[0, 0.5, 1]}
        headerTextStyleOverride={styles.headerText}
        headerContainerStyleOverride={styles.headerContainerStyleOverride}
        preventClose={false}
      >
        <SafeAreaView style={styles.footerContentContainer}>
          <ScrollView style={styles.footerContentScrollContainer}>
            <View style={styles.footerInnerContent}>
              {bankAccounts.map((bankAccount: BankAccount) => (
                <BankAccountItem key={bankAccount.id} {...bankAccount} />
              ))}
            </View>
          </ScrollView>
          <TouchableOpacity style={styles.linkAccountButton} onPress={handleLinkBankAccount}>
            <Text style={styles.linkAccountButtonText} allowFontScaling={false}>{_m('Link a Different Account')}</Text>
            <SkillzSVG
              source={'icon_right_arrow.svg'}
              tintColor={'#367BCE'}
              style={styles.rightArrowIcon}
            />
          </TouchableOpacity>
        </SafeAreaView>
      </FooterToastDrawer>
    </View>
  );
};

export default FooterSelectionDrawer;
